
            const data = {"name":"burger","data":{"width":"24","height":"23","viewBox":"0 0 24 23","data":"<path pid=\"0\" _fill=\"#fff\" d=\"M0 0h24v5H0zM0 9h24v5H0zM0 18h24v5H0z\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    